import React from 'react';
import { Modal, CustomModalLayout } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials-standalone';
import { communityNavSubHeaderDataHooks } from '../../CommunityNavSubHeader.dataHooks';
import CommunityNavModalMainScreen from '../CommunityNavModalMainScreen/CommunityNavModalMainScreen';
import s from './CommunityNavModal.module.scss';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

const CommunityNavModal = ({ isOpen, onClose }: Props) => {
  const { t } = useTranslation();

  return (
    <Modal isOpen={isOpen} screen="full" onRequestClose={onClose}>
      <CustomModalLayout
        className={s.fullscreenModal}
        dataHook={communityNavSubHeaderDataHooks.mobileModal()}
        title={t('marketplace.community-nav-sub-header.title')}
        onCloseButtonClick={onClose}
      >
        <CommunityNavModalMainScreen />
      </CustomModalLayout>
    </Modal>
  );
};

export default CommunityNavModal;
